import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  container: {
    backgroundColor: theme.colors.card_background_primary_editable,
    paddingRight: theme.spacing(8),
    paddingLeft: theme.spacing(8),
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(3)
  },
  mortgagesContainer: {
    padding: theme.spacing(0, 6, 3, 8),
    paddingTop: 0,
    backgroundColor: theme.colors.card_background_primary_editable,
    borderTop: `1px solid ${theme.colorPalette.white}`,
    width: '100%'
  },
  mortgageForm: {
    width: '100%',
    marginBottom: 0
  }
});

export default makeStyles(styles);
